var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-expansion",style:(_vm.showState),attrs:{"id":"image-expansion"},on:{"click":_vm.hideImage}},[_c('img',{staticClass:"image-expansion__image",attrs:{"src":_vm.src,"alt":"拡大イメージ"}})])}
var staticRenderFns = []

export { render, staticRenderFns }